import { type IMerchModule } from '@pcln/contentful-components'
import { Fragment } from 'react'
import MerchModuleWrapper from '.'
import LayoutComponentWrapper from '../LayoutComponentWrapper'

function PromoBanners({ merchModules }: { merchModules: ReadonlyArray<IMerchModule> }) {
  return merchModules.length > 0 ? (
    <LayoutComponentWrapper>
      {merchModules.map((merchModule) => {
        return (
          <Fragment key={merchModule?.internalName}>
            <MerchModuleWrapper content={merchModule} />
          </Fragment>
        )
      })}
    </LayoutComponentWrapper>
  ) : null
}

export default PromoBanners
